// Records utils
import debugLog from './debugLog'

export const bank_account2str = (bank_account) => {
  if (!bank_account)
    return ''
  const ba = bank_account
  if (ba.account_type < 3) {
    const types = ['', '普通', '当座']
    return `${ba.bank_name} ${ba.branch} ${types[ba.account_type]} ${ba.account_number}`
  } else {
    return `${ba.bank_name} 記号 ${ba.branch} 番号 ${ba.account_number}`
  }
}

export const percent_str = (val) => {
  return (`${val * 100} %`)
}

export const dateFormat = (date, format)  => {
    format = format.replace(/YYYY/, date.getFullYear());
    format = format.replace(/MM/, date.getMonth() + 1);
    format = format.replace(/DD/, date.getDate());
    return format;
}

export const nc = (val) => {
  // debugLog({val: val, s: String(val).length})
  // if (val && String(val).length)
  if (val)
    return Number(val).toLocaleString()
  else
    return ''
}

export const helperMethods = {
  bank_account2str,
  percent_str,
  nc,
  debugLog
}
